import { CountryInfo } from '@sharedModule/models/country.model';

export const SOURCE_COUNTRY_STATE = 'sourceCountries';

export interface SourceCountryState {
  isLoading: boolean;
  data: CountryInfo[];
  error?: string;
}

export const initialSourceCountryState: SourceCountryState = Object.freeze({
  isLoading: false,
  data: [],
  error: '',
});
